import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CalendarPlatform } from 'src/meetings/models';

export const useStartCalendarOAuthMutation = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: { url: string } }, Error, CalendarPlatform>({
    mutationFn: (platform: CalendarPlatform) =>
      api.post<{ url: string }>('calendars/start-oauth-flow', { platform }),
  });

  const startOAuth = async (platform: CalendarPlatform) => {
    const response = await mutateAsync(platform);
    return response.data;
  };

  return {
    startOAuth,
    isLoading,
    isError,
  };
};
